import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data || response
          // 兼容不同的返回格式
          let tokenStr = ''
          if (data.tokenHead && data.token) {
            tokenStr = data.tokenHead + data.token
          } else if (data.token) {
            tokenStr = data.token
          } else if (data.accessToken) {
            tokenStr = data.accessToken
          } else if (typeof data === 'string') {
            tokenStr = data
          }
          if (tokenStr) {
            setToken(tokenStr)
            commit('SET_TOKEN', tokenStr)
            resolve()
          } else {
            reject(new Error('Login failed: no token received'))
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          // 新接口返回格式：{ code: 0, data: {...}, message: "string" }
          // code 为 0 表示成功
          let data = null
          if (response.code === 0 && response.data) {
            // 新接口格式
            data = response.data
          } else if (response.data) {
            // 兼容旧接口格式
            data = response.data
          } else {
            // 直接是数据
            data = response
          }
          
          if (data) {
            // 保存用户基本信息
            commit('SET_NAME', data.username || data.nickname || '')
            commit('SET_AVATAR', data.icon || '')
            
            // 新接口没有 roles 字段，设置默认角色或空数组
            // 如果需要权限控制，可以从其他字段判断或设置默认值
            if (data.roles && data.roles.length > 0) {
              commit('SET_ROLES', data.roles)
            } else {
              // 新接口没有 roles，设置默认空数组或根据 status 判断
              commit('SET_ROLES', [])
            }
            
            resolve({ data: data })
          } else {
            reject(new Error('Failed to get user info: invalid data format'))
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js